import React from 'react';
import { Route, Router, IndexRoute, Redirect } from 'react-router'

import RootView from 'Components/RootViewComponent';
import ForumsIndexView from 'Components/ForumsIndexViewComponent';
import ForumView from 'Components/ForumViewComponent';
import ThreadView from 'Components/ThreadViewComponent';
import SearchView from 'Components/SearchViewComponent';
import UserProfile from 'Components/UserprofileViewComponent';
import MessagesViewComponent from 'Components/MessagesViewComponent';
import MessagesFolderView from 'Components/messages/MessagesFolderViewComponent';
import MessageView from 'Components/messages/MessageViewComponent';
import OnlineView from 'Components/OnlineViewComponent';
import PageComponent from 'Components/PageComponent';
import ReleaseNotesView from 'Components/ReleaseNotesViewComponent';
import PortalPageView from 'Components/PortalPageComponent';
import RegisterView from 'Components/RegisterComponent';
import SettingsView from 'Components/SettingsComponent';
import UserCP from 'Components/userCPComponent';

// Check the conf if we have home active and what's the IndexRoute
let indexRoute = <IndexRoute component={ RootView } />,
	forumIndex = <Route path="forums" component={ ForumsIndexView } />;

try {
	let envConf = process.env.config || { IndexRoute: 'root', section: { home: true } };

	if( !envConf.section.home ) {
		switch( envConf.IndexRoute ) {
			case 'index':
			default:
				indexRoute = <IndexRoute component={ ForumsIndexView } />;
				forumIndex = null;
				break;
		}
	}
} catch( e ) {
	/* ignore and continue with default */
}

export default ( history ) => (
	<Router history={ history }>
		{/* Ensure v2 URL are compatible with v3 */}
		<Route path="/(forumsite/:id)" component={ PageComponent }>
			{ indexRoute }
			{ forumIndex }

			<Route path="forums/:forumId" component={ ForumView } />

			<Route path="topics/:threadId" component={ ThreadView } />

			<Route path="search/:searchId" component={ SearchView } />
			<Route path="following" component={ SearchView } />
			<Route path="latest" component={ SearchView } />

			<Route path="participated" component={ SearchView } />
			<Route path="updated" component={ SearchView } />

			<Route path="userprofile/:userid" component={ UserProfile } />

			<Route path="release" component={ ReleaseNotesView } />

			{/*<Route path="online" component={ OnlineComponent } />*/}

			<Route path="pms" component={ MessagesViewComponent } />
			<Route path="pms/:folderId" component={ MessagesFolderView } />
			<Route path="pm/:messageId" component={ MessageView } />
			<Route path="online" component={ OnlineView } />

			<Route path="portal/:pagename" component={ PortalPageView } />

			<Route path="register" component={ RegisterView } />
			<Route path="settings" component={ SettingsView } />
			<Route path="usercp" component={ UserCP } />

			{/* prevent incorrect URLs and redirect to home, this must be the last entry here */}
			<Redirect from="*" to="/" />
		</Route>
	</Router>
)


// WEBPACK FOOTER //
// ./src/routes.js